import { render, staticRenderFns } from "./DeviceDetailBox.vue?vue&type=template&id=32ada642&scoped=true&"
import script from "./DeviceDetailBox.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailBox.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailBox.vue?vue&type=style&index=0&id=32ada642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ada642",
  null
  
)

export default component.exports